import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "absolute mt-1 w-full bg-white border border-hk-cream-dark/40 rounded-xl shadow-lg overflow-y-auto",
  style: {"z-index":"9999","max-height":"12.5rem"}
}
const _hoisted_2 = ["onClick"]

import { ref, computed, onMounted, onUnmounted } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomSelect',
  props: {
    modelValue: {},
    options: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const open = ref(false);
const wrapper = ref<HTMLElement | null>(null);

const selectedLabel = computed(() => {
  const found = props.options.find((o) => o.value === props.modelValue);
  return found ? found.label : "";
});

const select = (val: number | string) => {
  emit("update:modelValue", val);
  open.value = false;
};

const onClickOutside = (e: MouseEvent) => {
  if (wrapper.value && !wrapper.value.contains(e.target as Node)) {
    open.value = false;
  }
};

onMounted(() => document.addEventListener("click", onClickOutside));
onUnmounted(() => document.removeEventListener("click", onClickOutside));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "wrapper",
    ref: wrapper,
    class: "relative"
  }, [
    _createElementVNode("button", {
      type: "button",
      class: "w-full text-left rounded-lg border border-gray-300 bg-white px-3 py-2 text-base text-hk-dark focus:border-hk-red focus:ring-1 focus:ring-hk-red/20 focus:outline-none flex items-center justify-between",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (open.value = !open.value))
    }, [
      _createElementVNode("span", null, _toDisplayString(selectedLabel.value), 1),
      (_openBlock(), _createElementBlock("svg", {
        class: _normalizeClass(["w-4 h-4 text-hk-gray transition-transform", open.value ? 'rotate-180' : '']),
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2",
        viewBox: "0 0 24 24"
      }, [...(_cache[1] || (_cache[1] = [
        _createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          d: "M19 9l-7 7-7-7"
        }, null, -1)
      ]))], 2))
    ]),
    _createVNode(_Transition, {
      "enter-active-class": "transition ease-out duration-150",
      "enter-from-class": "opacity-0 -translate-y-1",
      "enter-to-class": "opacity-100 translate-y-0",
      "leave-active-class": "transition ease-in duration-100",
      "leave-from-class": "opacity-100 translate-y-0",
      "leave-to-class": "opacity-0 -translate-y-1"
    }, {
      default: _withCtx(() => [
        (open.value)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (opt) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: opt.value,
                  class: _normalizeClass(["px-4 py-2.5 text-sm text-hk-dark cursor-pointer transition-colors hover:bg-hk-cream", opt.value === __props.modelValue ? 'bg-hk-cream-dark font-semibold' : '']),
                  onClick: ($event: any) => (select(opt.value))
                }, _toDisplayString(opt.label), 11, _hoisted_2))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 512))
}
}

})